import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=68719aba&scoped=true"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"
import style0 from "./pay.vue?vue&type=style&index=0&id=68719aba&prod&scoped=true&lang=css"
import style1 from "./pay.vue?vue&type=style&index=1&id=68719aba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68719aba",
  null
  
)

export default component.exports